export default __webpack_public_path__ + "static/richard-6ef11f649cf5ab0bc4816023aba5a49c.svg";